// Create a service that use viacep online service for search address by CEP that returns address, city, state and country

import axios from 'axios'

const request = axios.create({
  baseURL: 'https://viacep.com.br/ws/',
  timeout: 10000
})

const cepService = {
  getAddressByCep: async (cep) => {
    const response = await request.get(`${cep}/json`)
    if (response.status === 200) {
      return response.data
    }
    return null
  }
}

export default cepService
